// SkillsPage.js
import React from 'react';

const SkillsPage = () => {
  return (
    <div>
      <h3>Languages, Frameworks, & Data:</h3>
      <p>API Integration, Data Infrastructure, PostgreSQL</p>
      
      <h3>Cloud & DevOps:</h3>
      <p>AWS / Amazon Web Services, Databases, GCP / Google Cloud Platform, Kubernetes</p>
      
      <h3>Pipelines:</h3>
      <p>Automated Testing and Systems Monitoring, ETL/ELT, Workflow Automation</p>
      
      <h3>CI/CD:</h3>
      <p>Build Tools, Git, Terraform</p>
      
      <h3>Team Practices:</h3>
      <p>Agile, Collaboration, Documentation, JIRA</p>
      
      <h3>General Skills:</h3>
      <p>Meme Curation, System Design</p>
    </div>
  );
};

export default SkillsPage;